import axios from "axios";
import { aliasPlatform } from "../../../utils/helper";
import { updateActiveWebsite } from "../../api/retail/websiteStatusApi";
import { constantNone, TTypeRemainOrder } from "./retailSettingContext";
import moment from "moment";
import {
  ID_PACKAGE_SUPPORT,
  ID_PACKAGE_TRIAL,
  KEIVI_ID_PACKAGE_LITE,
  KEIVI_ID_PACKAGE_STANDARD,
  PACKAGE_BASIC,
  PACKAGE_SUPPORT,
} from "./package_shop_name";
import { OnboardingFeatureStateType } from "../../../store/slices/onboardingFeatureSlice";
import {
  BOOKING_PLATFORM,
  FNB_PLATFORM,
  RETAIL_PLATFORM,
  BOOKING_HOTEL_PLATFORM
} from "../../../utils/constant";
export interface ISetting {
  is_stocked: boolean;
  price_formula_id: string | undefined;
  promotion_formula_id: string | undefined;
  amount_sale: string | undefined;
  platform: string;
  typeRemainOrder?: TTypeRemainOrder;
  product_type_displayed?: number[] | undefined;
  allow_in_store_transaction?: boolean | false;
  show_remain?: boolean;
  branch_sync_ref_id?: string;
  custom_price_text?: string;
}

export function getAllowOrderWhenOutStock(typeRemainOrder?: TTypeRemainOrder) {
  return typeRemainOrder === "infinity";
}

export function getIsStocked(
  typeRemainOrder: TTypeRemainOrder,
  is_stocked: boolean
) {
  const allow_order_when_out_stock = getAllowOrderWhenOutStock(typeRemainOrder);
  if (allow_order_when_out_stock) {
    return false;
  }
  return is_stocked;
}

export const sendSetting = async ({
  is_stocked,
  price_formula_id,
  promotion_formula_id,
  amount_sale,
  platform,
  typeRemainOrder,
  product_type_displayed,
  allow_in_store_transaction,
  branch_sync_ref_id,
}: ISetting) => {
  const shortPl = aliasPlatform(platform);
  console.debug({price_formula_id, promotion_formula_id})
  const new_promotion_formula_id =
    promotion_formula_id === constantNone ? "" : promotion_formula_id;
  const new_formula_id =
    price_formula_id === constantNone ? "" : price_formula_id;
  let body: {
    is_stocked: boolean;
    price_formula_id: string | undefined;
    promotion_formula_id: string | undefined;
    amount_sale: string | undefined;
    allow_order_when_out_stock?: boolean;
    product_type_displayed?: number[];
    allow_in_store_transaction?: boolean;
    branch_sync_ref_id?: string;
  } = {
    is_stocked,
    price_formula_id: new_formula_id,
    promotion_formula_id: new_promotion_formula_id,
    amount_sale,
    product_type_displayed,
    ...(typeof allow_in_store_transaction !== "undefined" && {
      allow_in_store_transaction,
    }),
    branch_sync_ref_id,
  };
  if (typeRemainOrder) {
    const allow_order_when_out_stock =
      getAllowOrderWhenOutStock(typeRemainOrder);
    body.allow_order_when_out_stock = allow_order_when_out_stock;
    if (allow_order_when_out_stock) {
      body.is_stocked = false;
    }
  }

  return await axios.put(`/api/v1/${shortPl}/branch/setting`, body);
};

export const settingTransactionMethod = async ({
  allow_in_store_transaction,
  platform,
}: {
  allow_in_store_transaction: boolean;
  platform: string;
}) => {
  const shortPl = aliasPlatform(platform);
  const body = {
    allow_in_store_transaction,
  };

  return await axios.put(
    `/api/v2/merchants/retail/setting/update-transaction-method`,
    body
  );
};

export const updateIsVisible = async ({ active_noty }: any) => {
  return await axios.put(`/api/v1/retail/branch/update-is-visible`, {
    is_visible: active_noty,
  });
};

export async function updateActiveWebsiteStatus(
  platform: TPlatform = "retail",
  newActiveStatus: boolean,
  changeStatusPublished?: (newStatus: boolean) => void
) {
  const result = await updateActiveWebsite({
    is_active: true,
    platform: platform,
  });
  if (result.status === 200) {
    changeStatusPublished && changeStatusPublished(newActiveStatus);
    return true;
  } else {
    return false;
  }
}

export const getKiotVietRetailSetting = async () => {
  return await axios.get(`/api/v1/retail/merchant/setting`);
};

export const getShopPackageSetting = async ({
  merchant_id,
  from = "admin-merchant",
  platform,
  isKeivi
}: {
  merchant_id: string | number;
  from: "iframe" | "admin-merchant";
  platform: string;
  isKeivi?: boolean
}) => {
  try {
    const url = `${process.env.REACT_APP_GATEWAY_API}/api/v2/merchants/package/state`;
    const listPackagesWithCheckSubscription = isKeivi ? [KEIVI_ID_PACKAGE_LITE, KEIVI_ID_PACKAGE_STANDARD] : [ID_PACKAGE_SUPPORT]

    const response = await axios.get(url);
    let isShopEndOfSubscription = false;
    let isShopInactive = false;
    let isShowAlertEndSubscription = false;
    let isShopUpgradePackageSuccess = response.data.is_display_package_upgraded;
    let timeStampCheckSubscription =
      process.env.REACT_APP_DATE_CHECK_END_SUBSCRIPTION_RETAIL;

    switch (platform) {
      case FNB_PLATFORM:
        timeStampCheckSubscription =
          process.env.REACT_APP_DATE_CHECK_END_SUBSCRIPTION_FNB;
        break;
      case BOOKING_PLATFORM:
        timeStampCheckSubscription = process.env.REACT_APP_DATE_CHECK_END_SUBSCRIPTION_BOOKING
        break
      case BOOKING_HOTEL_PLATFORM:
        timeStampCheckSubscription = process.env.REACT_APP_DATE_CHECK_END_SUBSCRIPTION_BOOKING_HOTEL
        break
    }

    if (!response.data.is_check) {
      return {
        success: true,
        data: {
          ...response.data,
          isShopUpgradePackageSuccess,
          isShowAlertEndSubscription,
          isShopInactive,
          isShopEndOfSubscription,
        }
      }
    }

    if (!listPackagesWithCheckSubscription.includes(response.data.active_package_id)) {
      return {
        success: true,
        data: {
          ...response.data,
          isShopUpgradePackageSuccess,
          isShowAlertEndSubscription,
          isShopInactive,
          isShopEndOfSubscription,
        },
      };
    }
    if (response.data.onboarding_at) {
      if (
        moment(new Date(response.data.onboarding_at)).isBefore(
          timeStampCheckSubscription
        )
      ) {
        console.debug("Onboarding at is before check subscription");
        return {
          success: true,
          data: {
            ...response.data,
            isShopUpgradePackageSuccess,
            isShowAlertEndSubscription,
            isShopInactive,
            isShopEndOfSubscription,
          },
        };
      }
      const endSubDate = moment(new Date(response.data.onboarding_at));
      const rangeDateEndSub = 10;

      isShopEndOfSubscription =
        moment(new Date()).diff(endSubDate, "days") >= rangeDateEndSub;
      isShopInactive = moment(new Date()).diff(endSubDate, "days") >= 60;
      isShowAlertEndSubscription = isShopEndOfSubscription;
      const strEndSubLocalStorage = localStorage.getItem(
        `end-sub-status-${from}`
      );
      isShopUpgradePackageSuccess = response.data.is_display_package_upgraded;
      if (strEndSubLocalStorage?.length) {
        const dataEndSubLocalStorage = JSON.parse(strEndSubLocalStorage);
        const isSameDay = moment(new Date()).diff(
          moment(new Date(dataEndSubLocalStorage.timeIsOpen)),
          "days"
        );
        if (isSameDay < 1) {
          isShopEndOfSubscription = isShopInactive
            ? true
            : isShopEndOfSubscription
            ? dataEndSubLocalStorage.isOpenNotiEndSubscription
            : false;
        }
      }
      if (isShopUpgradePackageSuccess) {
        isShopEndOfSubscription = false;
        isShopInactive = false;
        isShowAlertEndSubscription = false;
      }
      localStorage.setItem(
        `end-sub-status-${from}`,
        JSON.stringify({
          isOpenNotiEndSubscription: isShopEndOfSubscription,
          isShopInactive,
          timeIsOpen: new Date(),
        })
      );
    }
    return {
      success: true,
      data: {
        ...response.data,
        isShopEndOfSubscription,
        isShopInactive,
        isShowAlertEndSubscription,
        isShopUpgradePackageSuccess,
      },
    };
  } catch (error) {
    return {
      success: false,
      error,
    };
  }
};

export const fetchShopOnboardingFeature = async () => {
  const response = await axios.get(`api/v2/merchants/retail/active-feature`);
  const features: any = {
    popup: false,
    video_page_builder: false,
    video_merchandise_and_price: false,
    video_theme_store: false,
    video_product: false,
    video_product_category: false,
    video_hot_category: false,
    blog: false,
  } as OnboardingFeatureStateType;
  if (response.status === 200) {
    Object.keys(response.data.settings).forEach((key: string) => {
      if (response.data.settings.hasOwnProperty(key)) {
        features[key] = response.data.settings[key];
      }
    });
    console.debug({ features });
    return {
      success: true,
      data: { ...features },
    };
  }

  return {
    success: false,
    data: { ...features },
  };
};

export const updateShopOnboardingFeature = async (type: string) => {
  const platform = localStorage.getItem("mykiot_platform") || RETAIL_PLATFORM;
  const response = await axios.put(
    `api/v2/merchants/${platform}/active-feature?type=${type}`
  );
  if (response.status === 200) {
    return {
      success: true,
    };
  }
  return {
    success: false,
  };
};

export const sendSettingProducts = async ({
  is_stocked,
  price_formula_id,
  promotion_formula_id,
  amount_sale,
  platform,
  typeRemainOrder,
  product_type_displayed,
  allow_in_store_transaction,
  show_remain,
  custom_price_text
}: ISetting) => {
  const shortPl = aliasPlatform(platform);
  const new_promotion_formula_id =
    promotion_formula_id === constantNone ? "" : promotion_formula_id;
  let body: {
    is_stocked: boolean;
    price_formula_id: string | undefined;
    promotion_formula_id: string | undefined;
    amount_sale: string | undefined;
    allow_order_when_out_stock?: boolean;
    product_type_displayed?: number[];
    allow_in_store_transaction?: boolean;
    show_remain: boolean;
    custom_price_text?: string;
  } = {
    is_stocked,
    price_formula_id,
    promotion_formula_id: new_promotion_formula_id,
    amount_sale,
    product_type_displayed,
    ...(typeof allow_in_store_transaction !== "undefined" && {
      allow_in_store_transaction,
    }),
    show_remain: show_remain || false,
    custom_price_text,
  };
  if (typeRemainOrder) {
    const allow_order_when_out_stock =
      getAllowOrderWhenOutStock(typeRemainOrder);
    body.allow_order_when_out_stock = allow_order_when_out_stock;
    if (allow_order_when_out_stock) {
      body.is_stocked = false;
    }
  }

  return await axios.put(
    `api/v2/merchants/${shortPl}/setting/merchandise`,
    body
  );
};

export const sendSyncSetting = async ({
  is_stocked,
  price_formula_id,
  promotion_formula_id,
  amount_sale,
  platform,
  typeRemainOrder,
  product_type_displayed,
  allow_in_store_transaction,
  branch_sync_ref_id,
}: ISetting) => {
  const new_promotion_formula_id =
    promotion_formula_id === constantNone ? "" : promotion_formula_id;
  const new_price_formula_id =
    price_formula_id === constantNone ? "" : price_formula_id;
  let body: {
    is_stocked: boolean;
    price_formula_id: string | undefined;
    promotion_formula_id: string | undefined;
    amount_sale: string | undefined;
    allow_order_when_out_stock?: boolean;
    product_type_displayed?: number[];
    allow_in_store_transaction?: boolean;
    branch_sync_ref_id?: number;
  } = {
    is_stocked,
    price_formula_id: new_price_formula_id,
    promotion_formula_id: new_promotion_formula_id,
    amount_sale,
    product_type_displayed,
    ...(typeof allow_in_store_transaction !== "undefined" && {
      allow_in_store_transaction,
    }),
    branch_sync_ref_id: Number(branch_sync_ref_id),
  };
  if (typeRemainOrder) {
    const allow_order_when_out_stock =
      getAllowOrderWhenOutStock(typeRemainOrder);
    body.allow_order_when_out_stock = allow_order_when_out_stock;
    if (allow_order_when_out_stock) {
      body.is_stocked = false;
    }
  }

  return await axios.put(`/api/v2/merchants/branch/retail/settings`, body);
};

export const getSaleProductSettingFromRetail = async () => {
  return await axios.get(`api/v2/merchants/retail/setting`);
};
